var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconPaste = function SvgS2IconPaste(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 21 20"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "s2_icon_paste_svg__a",
    width: 21,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.015 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.765 18.002h-11.5c-1.24 0-2.25-1.01-2.25-2.25v-9.5c0-1.24 1.01-2.25 2.25-2.25h2.252a3.467 3.467 0 0 1 1.08-2.426A3.451 3.451 0 0 1 10.171.61c1.753.076 3.195 1.572 3.332 3.392h2.261c1.24 0 2.25 1.01 2.25 2.25v9.5c0 1.24-1.01 2.25-2.25 2.25Zm-11.5-12.5a.751.751 0 0 0-.75.75v9.5c0 .413.337.75.75.75h11.5c.413 0 .75-.337.75-.75v-9.5a.751.751 0 0 0-.75-.75h-.75v1.25c0 1.24-1.01 2.25-2.25 2.25h-5.5c-1.24 0-2.25-1.01-2.25-2.25l-.036-1.25h-.714Zm2.25 0v1.25c0 .413.337.75.75.75h5.5c.413 0 .75-.337.75-.75v-1.25h-.75a.75.75 0 0 1-.75-.75v-.466c0-1.155-.856-2.132-1.908-2.178-.558-.012-1.076.171-1.474.552-.398.381-.618.895-.618 1.446v.646a.75.75 0 0 1-.75.75h-.75Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s2_icon_paste_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.015 0h20v20h-20z"
  }))));
};
export default SvgS2IconPaste;